// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTopAppBar-VeloTopAppBarTitle_cls1__hVO-L","cls2":"VeloTopAppBar-VeloTopAppBarTitle_cls2__G++KP VeloTopAppBar-VeloTopAppBarTitle_cls1__hVO-L"};